import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { setNotificationMessage } from '../../../redux/features/general/notification';


interface Props { 
    icon?: React.ReactNode; 
    title: string; 
    titleStyle?: any; 
    handler?: any; 
    description?: any; 
    descriptionIcon?: any; 
    extraStyle?: any; 
    descriptionStyle?: any; 
    isDisabled?: boolean; 
    listIcon?: any; 
    listIconStyle?: any; 
    listExtraStyle?: any;
    listHandler?: any; 
    listHeight?: number;
    rowIcon?: any; 
    rowTitle?: any; 
    rowDescription?: any; 
    rowDescriptionStyle?: any; 
    rowExtraStyle?: any; 
    dataList?: any[]; 
}; 

const InfoRow: React.FC<Props> = ({ icon, title, titleStyle, handler, extraStyle, description, descriptionIcon, descriptionStyle, isDisabled, listIcon, listIconStyle, dataList, listExtraStyle, rowIcon, rowTitle, rowDescription, rowExtraStyle, rowDescriptionStyle, listHandler, listHeight }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const [isDataListOpened, setIsDataListOpened] = useState(false); 

    // -- 

    const handleDataList = () => { 

        if (isDisabled) { 
            return; 
        }; 

        setIsDataListOpened(!isDataListOpened); 

    }; 

    // -- 

    const handleSelection = async (item: any) => { 

        if (isDisabled) { 
            return; 
        }; 

        if (item) { 

            listHandler(item); 

            setIsDataListOpened(false); 

        };

    }; 

    // -- 

    const copyTextToClipboard = async ()  => {
        
        if (isDisabled) { 
            return; 
        }; 

        await navigator.clipboard.writeText(description);

        dispatch(setNotificationMessage(String(`${t(title)} ${t('copied')}!`))); 

    };

    // -- 

    return (

        <>

        <Box
            onClick={handler}
            onDoubleClick={copyTextToClipboard}
            sx={[{ 
                display: 'flex',
                cursor: isDisabled ? 'default' : 'pointer', 
                flexDirection: 'row', 
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 1, 
                width: '95%',
                borderRadius: 2, 
                padding: 1, 
                fontSize: 14, 
                color: colors?.text, 
                backgroundColor: 'transparent', 
                '&:hover': { backgroundColor: isDisabled ? 'transparent' : 'rgb(212,214,226)' }
            }, extraStyle]}
        >
            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}
            >

                {icon}

                <Box sx={[{ marginLeft: 1}, titleStyle]}>{t(title)}</Box>

            </Box>

            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}
            >

                <Box
                    sx={[{ 
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }, descriptionStyle]}
                >

                    {description}

                </Box>

                {descriptionIcon && 
                
                <Box    
                    sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginLeft: 1, 
                }}>{descriptionIcon}</Box>}

                    
                {dataList && 

                <Box
                    onClick={handleDataList}
                    sx={{ 
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-evenly', 
                        color: colors?.main,
                        marginLeft: 1, 
                        borderRadius: 3, 
                        cursor: 'pointer', 
                        fontSize: 30, 
                        '&:hover': { backgroundColor: 'rgb(192,194,206)' }
                    }}
                >

                    {isDataListOpened ? 
                        <KeyboardArrowUpIcon sx={{ fontSize: 30 }} /> : 
                        <KeyboardArrowDownIcon sx={{ fontSize: 30 }} />}

                </Box>}

            </Box>

        </Box>

        {(dataList && isDataListOpened) && 
        
            <Box sx={[{ 
                width: '100%', 
                backgroundColor: colors?.createPatientOptionsList,
                borderRadius: 3, 
                fontSize: 12,
                position: 'relative',
                paddingTop: 1, 
                marginBottom: 3, 
                zIndex: 20,
                left: 0,
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',  
            }, listExtraStyle]}>
    
                {dataList?.length >= 1 && 
    
                <Box 
                    
                    sx={{ 
                        width: '100%',
                        height: listHeight ? listHeight : 250,
                        overflowY: 'scroll', 
                    }}>
    
                    <List dense disablePadding>
    
                    {dataList?.map((item: any, index) => (
    
                        <ListItem onClick={() => handleSelection(item)} button key={index} disablePadding>
    
                            <InfoRow
                                key={index}
                                handler={handleSelection}
                                title={item[rowTitle]}
                                icon={rowIcon}
                                description={item[rowDescription]}
                                extraStyle={rowExtraStyle}
                                descriptionStyle={rowDescriptionStyle}
                            />  
    
                        </ListItem>
    
                    ))}
    
                    </List>
    
                </Box>}
                        
            </Box>}

    </>

  );

};

export default InfoRow;

